<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    :width="size"
    :height="size"
    viewBox="0 0 160.472 160.81"
    enable-background="new 0 0 160.472 160.81"
    xml:space="preserve"
  >
    <g>
      <g>
        <g>
          <g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              fill="#F2875C"
              d="M139.271,0h-56.92c-2.909,0-5.68,0.588-8.204,1.649h2.37
            c11.47,0,20.767,9.298,20.767,20.767v115.979c0,11.468-9.297,20.767-20.767,20.767h-2.369c2.523,1.061,5.294,1.648,8.203,1.648
            h56.92c11.71,0,21.201-9.492,21.201-21.201V21.202C160.472,9.493,150.98,0,139.271,0z"
            />
          </g>
        </g>
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          stroke-width="2"
          stroke-miterlimit="10"
          d="M117.392,66.03l5.836,3.645l17.503,10.931
        l-3.502,2.135l-19.837,12.095V66.03 M116.054,61.839c-0.989,0-1.754,0.99-1.754,2.079c0,7.712,0,26.184,0,33.43
        c0,1.222,0.622,1.623,1.37,1.623c0.56,0,1.191-0.223,1.686-0.496c6.372-3.884,20.962-12.776,26.794-16.331
        c1.086-0.666,1.614-2.155,0.066-3.007c-5.863-3.663-20.882-13.04-27.125-16.94C116.732,61.948,116.381,61.839,116.054,61.839
        L116.054,61.839z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#181716"
            d="M78.182,9c6.728,0,12.201,5.474,12.201,12.202v118.408c0,6.728-5.474,12.201-12.201,12.201H21.262
          c-6.727,0-12.2-5.473-12.2-12.201V21.202C9.062,14.474,14.535,9,21.262,9H78.182 M78.182,0H21.262
          c-11.707,0-21.2,9.493-21.2,21.202v118.408c0,11.708,9.493,21.201,21.2,21.201h56.919c11.71,0,21.201-9.492,21.201-21.201V21.202
          C99.383,9.493,89.892,0,78.182,0L78.182,0z"
          />
        </g>
        <g>
          <path
            fill="#181716"
            d="M49.639,90.412c12.742,0,23.069,10.327,23.069,23.068c0,12.74-10.327,23.069-23.069,23.069
          c-12.738,0-23.067-10.329-23.067-23.069C26.571,100.739,36.9,90.412,49.639,90.412 M49.639,81.412
          c-17.682,0-32.067,14.386-32.067,32.068c0,17.683,14.385,32.069,32.067,32.069c17.683,0,32.069-14.386,32.069-32.069
          C81.708,95.798,67.322,81.412,49.639,81.412L49.639,81.412z"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="none"
          stroke="#181716"
          stroke-width="9"
          stroke-miterlimit="10"
          d="
        M72.957,46.223L49.388,69.806L25.82,46.22c-2.649-2.7-4.285-6.399-4.285-10.481c0-8.267,6.702-14.968,14.968-14.968
        c5.485,0,10.278,2.949,12.885,7.347c2.606-4.398,7.401-7.347,12.884-7.347c8.268,0,14.97,6.701,14.97,14.968
        C77.242,39.821,75.606,43.522,72.957,46.223z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#181716"
          d="M49.64,105.223c4.561,0,8.26,3.698,8.26,8.257
        c0,4.562-3.699,8.258-8.26,8.258c-4.56,0-8.257-3.696-8.257-8.258C41.383,108.921,45.08,105.223,49.64,105.223z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20
    }
  }
}
</script>
